import React from 'react';
import MyReviewTable from '../components/dashboard/MyReviewTable';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import ModalMenu from '../components/Modal/ModalMenu';
import ModalSearch from '../components/Modal/ModalSearch';
import Scrollup from '../components/Scrollup/Scrollup';



const MyReview = () => {

   

    
        return (

            <div className="main">
                <Header />
               <MyReviewTable/>
                <Footer/>
                <ModalSearch />
                <ModalMenu />
                <Scrollup />
            </div>

            
        );
    }


export default MyReview;